import clsx from "clsx";
import { useEffect, useState } from "react";

const HERO_LOGO_LIGHT = "/static/img/hero-logo.png";
const HERO_LOGO_DARK = "/static/img/hero-logo-dark.png";

function readIsDark(): boolean {
  if (typeof document === "undefined") return false;
  const root = document.documentElement;
  if (root.getAttribute("data-theme") === "dark") return true;
  return root.classList.contains("dark");
}

function useHeroLogoSrc(): string {
  const [src, setSrc] = useState(() =>
    readIsDark() ? HERO_LOGO_DARK : HERO_LOGO_LIGHT,
  );
  useEffect(() => {
    const root = document.documentElement;
    const sync = () => setSrc(readIsDark() ? HERO_LOGO_DARK : HERO_LOGO_LIGHT);
    const obs = new MutationObserver(sync);
    obs.observe(root, { attributes: true, attributeFilter: ["data-theme", "class"] });
    return () => obs.disconnect();
  }, []);
  return src;
}

/** Kleines Hero-Logo für Tabellen-Header (Spalte Hero-Link). */
export function HeroHeaderLogo({ className }: { className?: string }) {
  const src = useHeroLogoSrc();
  return (
    <img
      src={src}
      alt=""
      className={className}
      width={24}
      height={24}
      loading="lazy"
      decoding="async"
    />
  );
}

/** Inline Hero-Logo in Textzeilen – maximal Schrifthöhe, Theme-aware wie bei Projekten. */
export function HeroInlineLogo({ className }: { className?: string }) {
  const src = useHeroLogoSrc();
  return (
    <img
      src={src}
      alt=""
      className={clsx(
        "inline-block h-[1em] w-auto max-h-[1em] shrink-0 object-contain align-[-0.125em]",
        className,
      )}
      loading="lazy"
      decoding="async"
    />
  );
}
